import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Input, Text, Box, Container, Flex } from "samba-ui";
import styled from "styled-components";
import {
  loadGroupPermissions,
  addNewGroupPermission,
  updateGroupPermission,
  deleteGroupPermission
} from "../redux/groupPermissions";
import GroupPermissionList from "./GroupPermissionList";
import PageLoader from "./PageLoader";

const StyledInput = styled(Input)`
  width: 100%;
`;

const ManageGroupPermissions = ({
  user,
  permissions,
  loadGroupPermissions,
  addNewGroupPermission,
  updateGroupPermission,
  deleteGroupPermission
}) => {
  const isSuperOperator = user.role === "superoperator";
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  if (searchValue) {
    permissions = Object.keys(permissions)
      .filter(
        id =>
          permissions[id].name
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) > -1
      )
      .reduce((acc, id) => {
        acc[id] = permissions[id];
        return acc;
      }, {});
  }

  useEffect(() => {
    const req = async () => {
      await loadGroupPermissions();
    };
    req();
  }, [loadGroupPermissions]);

  const onSubmit = async body => {
    setLoading(true);
    await addNewGroupPermission(body);
    setLoading(false);
  };

  const onUpdate = async (id, body) => {
    setLoading(true);
    await updateGroupPermission(id, body);
    setLoading(false);
  };

  const onDelete = async id => {
    setLoading(true);
    await deleteGroupPermission(id);
    setLoading(false);
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <Container maxWidth={2048} minWidth={960}>
      <Flex>
        <Box width={3 / 4} mr={4}>
          <GroupPermissionList
            permissions={permissions}
            onSubmit={onSubmit}
            onUpdate={onUpdate}
            onDelete={onDelete}
            isSuperOperator={isSuperOperator}
          />
        </Box>
        <Box width={1 / 4} pt={5}>
          <Box mb={2}>
            <Text fontWeight={1} fontSize={0} color="palette.ink.light">
              Search permission
            </Text>
          </Box>
          <StyledInput
            placeholder="Search..."
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
          />
        </Box>
      </Flex>
    </Container>
  );
};

const mapStateToProps = (state, props) => ({
  permissions: state.groupPermissions
});

const mapDispatchToProps = dispatch => ({
  loadGroupPermissions: () => dispatch(loadGroupPermissions()),
  addNewGroupPermission: body => dispatch(addNewGroupPermission(body)),
  updateGroupPermission: (id, body) =>
    dispatch(updateGroupPermission(id, body)),
  deleteGroupPermission: id => dispatch(deleteGroupPermission(id))
});

ManageGroupPermissions.propTypes = {
  permissions: PropTypes.object,
  user: PropTypes.object,
  loadGroupPermissions: PropTypes.func,
  addNewGroupPermission: PropTypes.func,
  updateGroupPermission: PropTypes.func,
  deleteGroupPermission: PropTypes.func
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageGroupPermissions);
